import { all, put, retry } from 'redux-saga/effects';
import { reject, resolve } from '../api';
import * as types from '../constants';
import { authClient } from '../api/Client';
import { NOTIFICATION } from '../constants';
import {
  errorNotification,
  showNotification,
  successNotification,
  simpleErrorNotification,
} from '../../shared-components/Notifications';
import {
  loadCustomerOrganizationUsersList as loadCustomerOrganizationUsersListAction,
  loadCustomerOrganization as loadCustomerOrganizationAction,
  loadCustomerOrganizationsList as loadCustomerOrganizationsListAction,
} from '../actions/staff';

export function* loadCustomerOrganizationsList() {
  try {
    const res = yield retry(
      4,
      500,
      authClient?.Staff?.loadCustomerOrganizationList,
    );

    yield put({
      type: resolve(types?.LOAD_CUSTOMER_ORGANIZATIONS_LIST),
      payload: res?.data(),
    });
  } catch (error) {
    yield all([
      put({
        type: reject(types?.LOAD_CUSTOMER_ORGANIZATIONS_LIST),
        error,
      }),
      put({
        type: NOTIFICATION?.ADD_NOTIFICATION,
        notification: errorNotification(
          error,
          reject(types?.LOAD_CUSTOMER_ORGANIZATIONS_LIST),
        ),
      }),
    ]);
  }
}

export function* loadCustomerOrganizationsListPage({ page, searchText }) {
  try {
    const res = yield retry(
      4,
      500,
      authClient?.Staff?.loadCustomerOrganizationListPage,
      { page: page, searchText: searchText },
    );

    yield put({
      type: resolve(types?.LOAD_CUSTOMER_ORGANIZATIONS_LIST_PAGE),
      payload: res?.data(),
    });
  } catch (error) {
    yield all([
      put({
        type: reject(types?.LOAD_CUSTOMER_ORGANIZATIONS_LIST_PAGE),
        error,
      }),
      put({
        type: NOTIFICATION?.ADD_NOTIFICATION,
        notification: errorNotification(
          error,
          reject(types?.LOAD_CUSTOMER_ORGANIZATIONS_LIST_PAGE),
        ),
      }),
    ]);
  }
}

export function* updateCustomerOrganization({ data }) {
  try {
    const res = yield retry(
      4,
      500,
      authClient?.Staff?.updateCustomerOrganization,
      {
        uuid: data?.uuid,
        body: data,
      },
    );

    if (
      res?.responseStatus === 200 ||
      res?.responseStatus === 201 ||
      res?.responseStatus === 204
    ) {
      yield put({
        type: resolve(types?.UPDATE_CUSTOMER_ORGANIZATION),
        payload: res?.data(),
      });
      showNotification(
        successNotification({
          statusCode: 200,
          message: 'Organization updated',
        }),
      );
    } else {
      yield all([
        put({
          type: reject(types?.UPDATE_CUSTOMER_ORGANIZATION),
          res,
        }),
        showNotification(
          simpleErrorNotification({
            statusCode: res?.responseStatus,
            message:
              JSON.parse(res?.responseData)?.errors?.[0]?.message ??
              'An error has occurred while updating the organization.',
          }),
        ),
      ]);
    }
  } catch (error) {}

  //   yield put({
  //     type: resolve(types?.UPDATE_CUSTOMER_ORGANIZATION),
  //     payload: res?.data(),
  //   });
  //   showNotification(
  //     successNotification({
  //       statusCode: 200,
  //       message: 'Organization updated',
  //     }),
  //   );
  // } catch (error) {
  //   yield all([
  //     put({
  //       type: reject(types?.UPDATE_CUSTOMER_ORGANIZATION),
  //       error,
  //     }),
  //     put({
  //       type: NOTIFICATION?.ADD_NOTIFICATION,
  //       notification: errorNotification(
  //         error,
  //         reject(types?.UPDATE_CUSTOMER_ORGANIZATION),
  //       ),
  //     }),
  //   ]);
  // }
}

export function* loadCustomerSubscriptionPlan({ uuid }) {
  try {
    const res = yield retry(
      1,
      500,
      authClient?.Staff?.loadCustomerSubscriptionPlan,
      { uuid: uuid },
    );

    yield put({
      type: resolve(types?.LOAD_CUSTOMER_SUBSCRIPTION_PLAN),
      payload: res?.data(),
    });
  } catch (error) {
    yield all([
      put({
        type: reject(types?.LOAD_CUSTOMER_SUBSCRIPTION_PLAN),
        error,
      }),
    ]);
  }
}

export function* createCustomerSubscription({ data }) {
  try {
    const res = yield retry(
      4,
      500,
      authClient?.Staff?.createCustomerSubscription,
      {
        body: data,
      },
    );

    if (
      res?.responseStatus === 200 ||
      res?.responseStatus === 201 ||
      res?.responseStatus === 204
    ) {
      yield put({
        type: resolve(types?.CREATE_CUSTOMER_SUBSCRIPTION),
        payload: res?.data(),
      });
      showNotification(
        successNotification({
          statusCode: 200,
          message: 'Subscription created',
        }),
      );
    } else {
      yield all([
        put({
          type: reject(types?.CREATE_CUSTOMER_SUBSCRIPTION),
          res,
        }),
        showNotification(
          simpleErrorNotification({
            statusCode: res?.responseStatus,
            message:
              JSON.parse(res?.responseData)?.errors?.[0]?.message ??
              'An error has occurred while creating the subscription.',
          }),
        ),
      ]);
    }
  } catch (error) {}

  //   yield put({
  //     type: resolve(types?.CREATE_CUSTOMER_SUBSCRIPTION),
  //     payload: res?.data(),
  //   });
  //   showNotification(
  //     successNotification({
  //       statusCode: 200,
  //       message: 'Subscription created',
  //     }),
  //   );
  // } catch (error) {
  //   yield all([
  //     put({
  //       type: reject(types?.CREATE_CUSTOMER_SUBSCRIPTION),
  //       error,
  //     }),
  //     put({
  //       type: NOTIFICATION?.ADD_NOTIFICATION,
  //       notification: errorNotification(
  //         error,
  //         reject(types?.CREATE_CUSTOMER_SUBSCRIPTION),
  //       ),
  //     }),
  //   ]);
  // }
}

export function* updateCustomerSubscription({ data }) {
  try {
    const res = yield retry(
      4,
      500,
      authClient?.Staff?.updateCustomerSubscription,
      {
        body: data,
        uuid: data?.uuid,
      },
    );

    if (
      res?.responseStatus === 200 ||
      res?.responseStatus === 201 ||
      res?.responseStatus === 204
    ) {
      yield put({
        type: resolve(types?.UPDATE_CUSTOMER_SUBSCRIPTION),
        payload: res?.data(),
      });
      showNotification(
        successNotification({
          statusCode: 200,
          message: 'Subscription updated',
        }),
      );
      yield put(loadCustomerOrganizationsListAction());
    } else {
      yield all([
        put({
          type: reject(types?.UPDATE_CUSTOMER_SUBSCRIPTION),
          res,
        }),
        showNotification(
          simpleErrorNotification({
            statusCode: res?.responseStatus,
            message:
              JSON.parse(res?.responseData)?.errors?.[0]?.message ??
              'An error has occurred while updating the user subscription.',
          }),
        ),
      ]);
    }
  } catch (error) {}

  //   yield put({
  //     type: resolve(types?.UPDATE_CUSTOMER_SUBSCRIPTION),
  //     payload: res?.data(),
  //   });
  //   showNotification(
  //     successNotification({
  //       statusCode: 200,
  //       message: 'Subscription updated',
  //     }),
  //   );
  // } catch (error) {
  //   yield all([
  //     put({
  //       type: reject(types?.UPDATE_CUSTOMER_SUBSCRIPTION),
  //       error,
  //     }),
  //     put({
  //       type: NOTIFICATION?.ADD_NOTIFICATION,
  //       notification: errorNotification(
  //         error,
  //         reject(types?.UPDATE_CUSTOMER_SUBSCRIPTION),
  //       ),
  //     }),
  //   ]);
  // }
}

export function* restrictSubscriptionCustomerOrganization({
  subscriptionUUID,
}) {
  try {
    const res = yield retry(
      1,
      500,
      authClient?.Staff?.restrictSubscriptionCustomerOrganization,
      {
        uuid: subscriptionUUID,
      },
    );

    if (
      res?.responseStatus === 200 ||
      res?.responseStatus === 201 ||
      res?.responseStatus === 204
    ) {
      yield put({
        type: resolve(types?.RESTRICT_SUBSCRIPTION_CUSTOMER_ORGANIZATION),
        payload: res?.data(),
      });
      showNotification(
        successNotification({
          statusCode: 200,
          message: 'Subscription restricted and notification sent',
        }),
      );
      yield put(loadCustomerOrganizationsListAction());
    } else {
      yield all([
        put({
          type: reject(types?.RESTRICT_SUBSCRIPTION_CUSTOMER_ORGANIZATION),
          res,
        }),
        showNotification(
          simpleErrorNotification({
            statusCode: res?.responseStatus,
            message:
              JSON.parse(res?.responseData)?.errors?.[0]?.message ??
              'An error has occurred while updating the user subscription.',
          }),
        ),
      ]);
    }
  } catch (error) {}

  //   yield put({
  //     type: resolve(types?.RESTRICT_SUBSCRIPTION_CUSTOMER_ORGANIZATION),
  //     payload: res?.data(),
  //   });
  //   showNotification(
  //     successNotification({
  //       statusCode: 200,
  //       message: 'Subscription restricted and notification sent',
  //     }),
  //   );
  //   yield put(loadCustomerOrganizationsListAction());
  // } catch (error) {
  //   yield all([
  //     put({
  //       type: reject(types?.RESTRICT_SUBSCRIPTION_CUSTOMER_ORGANIZATION),
  //       error,
  //     }),
  //     put({
  //       type: NOTIFICATION?.ADD_NOTIFICATION,
  //       notification: errorNotification(
  //         error,
  //         reject(types?.RESTRICT_SUBSCRIPTION_CUSTOMER_ORGANIZATION),
  //       ),
  //     }),
  //   ]);
  // }
}

export function* unrestrictSubscriptionCustomerOrganization({
  subscriptionUUID,
}) {
  try {
    const res = yield retry(
      1,
      500,
      authClient?.Staff?.unrestrictSubscriptionCustomerOrganization,
      {
        uuid: subscriptionUUID,
      },
    );

    if (
      res?.responseStatus === 200 ||
      res?.responseStatus === 201 ||
      res?.responseStatus === 204
    ) {
      yield put({
        type: resolve(types?.UNRESTRICT_SUBSCRIPTION_CUSTOMER_ORGANIZATION),
        payload: res?.data(),
      });
      showNotification(
        successNotification({
          statusCode: 200,
          message: 'Subscription unrestricted',
        }),
      );
      yield put(loadCustomerOrganizationsListAction());
    } else {
      yield all([
        put({
          type: reject(types?.UNRESTRICT_SUBSCRIPTION_CUSTOMER_ORGANIZATION),
          res,
        }),
        showNotification(
          simpleErrorNotification({
            statusCode: res?.responseStatus,
            message:
              JSON.parse(res?.responseData)?.errors?.[0]?.message ??
              'An error has occurred while updating the user subscription.',
          }),
        ),
      ]);
    }
  } catch (error) {}

  //   yield put({
  //     type: resolve(types?.UNRESTRICT_SUBSCRIPTION_CUSTOMER_ORGANIZATION),
  //     payload: res?.data(),
  //   });
  //   showNotification(
  //     successNotification({
  //       statusCode: 200,
  //       message: 'Subscription unrestricted',
  //     }),
  //   );
  //   yield put(loadCustomerOrganizationsListAction());
  // } catch (error) {
  //   yield all([
  //     put({
  //       type: reject(types?.UNRESTRICT_SUBSCRIPTION_CUSTOMER_ORGANIZATION),
  //       error,
  //     }),
  //     put({
  //       type: NOTIFICATION?.ADD_NOTIFICATION,
  //       notification: errorNotification(
  //         error,
  //         reject(types?.UNRESTRICT_SUBSCRIPTION_CUSTOMER_ORGANIZATION),
  //       ),
  //     }),
  //   ]);
  // }
}

export function* notifySubscriptionRestrictedCustomerOrganization({
  organisationID,
}) {
  try {
    const res = yield retry(
      1,
      500,
      authClient?.Staff?.notifySubscriptionRestrictedCustomerOrganization,
      {
        id: organisationID,
      },
    );

    if (
      res?.responseStatus === 200 ||
      res?.responseStatus === 201 ||
      res?.responseStatus === 204
    ) {
      yield put({
        type: resolve(
          types?.NOTIFY_SUBSCRIPTION_RESTRICTED_CUSTOMER_ORGANIZATION,
        ),
        payload: res?.data(),
      });
      showNotification(
        successNotification({
          statusCode: 200,
          message: 'Notification sent',
        }),
      );
    } else {
      yield all([
        put({
          type: reject(
            types?.NOTIFY_SUBSCRIPTION_RESTRICTED_CUSTOMER_ORGANIZATION,
          ),
          res,
        }),
        showNotification(
          simpleErrorNotification({
            statusCode: res?.responseStatus,
            message:
              JSON.parse(res?.responseData)?.errors?.[0]?.message ??
              'An error has occurred while sending the notification.',
          }),
        ),
      ]);
    }
  } catch (error) {}

  //   yield put({
  //     type: resolve(
  //       types?.NOTIFY_SUBSCRIPTION_RESTRICTED_CUSTOMER_ORGANIZATION,
  //     ),
  //     payload: res?.data(),
  //   });
  //   showNotification(
  //     successNotification({
  //       statusCode: 200,
  //       message: 'Notification sent',
  //     }),
  //   );
  // } catch (error) {
  //   yield all([
  //     put({
  //       type: reject(
  //         types?.NOTIFY_SUBSCRIPTION_RESTRICTED_CUSTOMER_ORGANIZATION,
  //       ),
  //       error,
  //     }),
  //     put({
  //       type: NOTIFICATION?.ADD_NOTIFICATION,
  //       notification: errorNotification(
  //         error,
  //         reject(types?.NOTIFY_SUBSCRIPTION_RESTRICTED_CUSTOMER_ORGANIZATION),
  //       ),
  //     }),
  //   ]);
  // }
}

export function* createCustomerOrganization({ data }) {
  try {
    const res = yield retry(
      4,
      500,
      authClient?.Staff?.createCustomerOrganization,
      {
        body: data,
      },
    );

    if (
      res?.responseStatus === 200 ||
      res?.responseStatus === 201 ||
      res?.responseStatus === 204
    ) {
      yield put({
        type: resolve(types?.CREATE_CUSTOMER_ORGANIZATION),
        payload: res?.data(),
      });
      showNotification(
        successNotification({
          statusCode: 200,
          message: 'Organization created',
        }),
      );
    } else {
      yield all([
        put({
          type: reject(types?.CREATE_CUSTOMER_ORGANIZATION),
          res,
        }),
        showNotification(
          simpleErrorNotification({
            statusCode: res?.responseStatus,
            message:
              JSON.parse(res?.responseData)?.errors?.[0]?.message ??
              'An error has occurred while creating the organization.',
          }),
        ),
      ]);
    }
  } catch (error) {}

  //   yield put({
  //     type: resolve(types?.CREATE_CUSTOMER_ORGANIZATION),
  //     payload: res?.data(),
  //   });
  //   showNotification(
  //     successNotification({
  //       statusCode: 200,
  //       message: 'Organization created',
  //     }),
  //   );
  // } catch (error) {
  //   yield all([
  //     put({
  //       type: reject(types?.CREATE_CUSTOMER_ORGANIZATION),
  //       error,
  //     }),
  //     put({
  //       type: NOTIFICATION?.ADD_NOTIFICATION,
  //       notification: errorNotification(
  //         error,
  //         reject(types?.CREATE_CUSTOMER_ORGANIZATION),
  //       ),
  //     }),
  //   ]);
  // }
}

export function* loadCustomerOrganization({ organisationUUID }) {
  try {
    const res = yield retry(
      4,
      500,
      authClient?.Staff?.loadCustomerOrganization,
      { uuid: organisationUUID },
    );

    yield put({
      type: resolve(types?.LOAD_CUSTOMER_ORGANIZATION),
      payload: res?.data(),
    });
  } catch (error) {
    yield all([
      put({
        type: reject(types?.LOAD_CUSTOMER_ORGANIZATION),
        error,
      }),
      put({
        type: NOTIFICATION?.ADD_NOTIFICATION,
        notification: errorNotification(
          error,
          reject(types?.LOAD_CUSTOMER_ORGANIZATION),
        ),
      }),
    ]);
  }
}

export function* deleteCustomerOrganization({ organisationUUID }) {
  try {
    const res = yield retry(
      1,
      500,
      authClient?.Staff?.deleteCustomerOrganization,
      { uuid: organisationUUID },
    );

    if (
      res?.responseStatus === 200 ||
      res?.responseStatus === 201 ||
      res?.responseStatus === 204
    ) {
      yield put({
        type: resolve(types?.DELETE_CUSTOMER_ORGANIZATION),
        payload: res?.data(),
      });
      showNotification(
        successNotification({
          statusCode: 200,
          message: 'Organization deleted',
        }),
      );
      yield put(loadCustomerOrganizationsListAction());
    } else {
      yield all([
        put({
          type: reject(types?.DELETE_CUSTOMER_ORGANIZATION),
          res,
        }),
        showNotification(
          simpleErrorNotification({
            statusCode: res?.responseStatus,
            message:
              JSON.parse(res?.responseData)?.errors?.[0]?.message ??
              'An error has occurred while deleting the organization.',
          }),
        ),
      ]);
    }
  } catch (error) {}

  //   yield put({
  //     type: resolve(types?.DELETE_CUSTOMER_ORGANIZATION),
  //     payload: res?.data(),
  //   });
  //   yield put(loadCustomerOrganizationsListAction());
  //   showNotification(
  //     successNotification({
  //       statusCode: 200,
  //       message: 'Organization deleted',
  //     }),
  //   );
  // } catch (error) {
  //   yield all([
  //     put({
  //       type: reject(types?.DELETE_CUSTOMER_ORGANIZATION),
  //       error,
  //     }),
  //     put({
  //       type: NOTIFICATION?.ADD_NOTIFICATION,
  //       notification: errorNotification(
  //         error,
  //         reject(types?.DELETE_CUSTOMER_ORGANIZATION),
  //       ),
  //     }),
  //   ]);
  // }
}

export function* loadCustomerOrganizationUsersList({ organisationID }) {
  try {
    const res = yield retry(
      4,
      500,
      authClient?.Staff?.loadCustomerOrganizationUsersList,
      { id: organisationID },
    );

    yield put({
      type: resolve(types?.LOAD_CUSTOMER_ORGANIZATION_USERS_LIST),
      payload: res?.data(),
    });
  } catch (error) {
    yield all([
      put({
        type: reject(types?.LOAD_CUSTOMER_ORGANIZATION_USERS_LIST),
        error,
      }),
      put({
        type: NOTIFICATION?.ADD_NOTIFICATION,
        notification: errorNotification(
          error,
          reject(types?.LOAD_CUSTOMER_ORGANIZATION_USERS_LIST),
        ),
      }),
    ]);
  }
}

export function* loadCustomerOrganizationUsersListPage({
  organisationID,
  page,
}) {
  try {
    const res = yield retry(
      4,
      500,
      authClient?.Staff?.loadCustomerOrganizationUsersListPage,
      { id: organisationID, page: page },
    );

    yield put({
      type: resolve(types?.LOAD_CUSTOMER_ORGANIZATION_USERS_LIST_PAGE),
      payload: res?.data(),
    });
  } catch (error) {
    yield all([
      put({
        type: reject(types?.LOAD_CUSTOMER_ORGANIZATION_USERS_LIST_PAGE),
        error,
      }),
      put({
        type: NOTIFICATION?.ADD_NOTIFICATION,
        notification: errorNotification(
          error,
          reject(types?.LOAD_CUSTOMER_ORGANIZATION_USERS_LIST_PAGE),
        ),
      }),
    ]);
  }
}

export function* updateCustomerOrganizationUser({
  organisationID,
  uuid,
  data,
}) {
  try {
    const res = yield retry(
      4,
      500,
      authClient?.Staff?.updateCustomerOrganizationUser,
      {
        body: data,
        id: organisationID,
        uuid: uuid,
      },
    );

    if (
      res?.responseStatus === 200 ||
      res?.responseStatus === 201 ||
      res?.responseStatus === 204
    ) {
      yield put({
        type: resolve(types?.UPDATE_CUSTOMER_ORGANIZATION_USER),
        payload: res?.data(),
      });
      showNotification(
        successNotification({
          statusCode: 200,
          message: 'User successfully updated!',
        }),
      );
    } else {
      yield all([
        put({
          type: reject(types?.UPDATE_CUSTOMER_ORGANIZATION_USER),
          res,
        }),
        showNotification(
          simpleErrorNotification({
            statusCode: res?.responseStatus,
            message:
              JSON.parse(res?.responseData)?.errors?.[0]?.message ??
              'An error has occurred while updating the user.',
          }),
        ),
      ]);
    }
  } catch (error) {}

  //   yield put({
  //     type: resolve(types?.UPDATE_CUSTOMER_ORGANIZATION_USER),
  //     payload: res?.data(),
  //   });
  //   showNotification(
  //     successNotification({
  //       statusCode: 200,
  //       message: 'User updated',
  //     }),
  //   );
  // } catch (error) {
  //   yield all([
  //     put({
  //       type: reject(types?.UPDATE_CUSTOMER_ORGANIZATION_USER),
  //       error,
  //     }),
  //     put({
  //       type: NOTIFICATION?.ADD_NOTIFICATION,
  //       notification: errorNotification(
  //         error,
  //         reject(types?.UPDATE_CUSTOMER_ORGANIZATION_USER),
  //       ),
  //     }),
  //   ]);
  // }
}

export function* createCustomerOrganizationUser({ organisationID, data }) {
  try {
    const res = yield retry(
      4,
      500,
      authClient?.Staff?.createCustomerOrganizationUser,
      {
        body: data,
        id: organisationID,
      },
    );

    if (
      res?.responseStatus === 200 ||
      res?.responseStatus === 201 ||
      res?.responseStatus === 204
    ) {
      yield put({
        type: resolve(types?.CREATE_CUSTOMER_ORGANIZATION_USER),
        payload: res?.data(),
      });
      showNotification(
        successNotification({
          statusCode: 200,
          message: 'User successfully created!',
        }),
      );
    } else {
      yield all([
        put({
          type: reject(types?.CREATE_CUSTOMER_ORGANIZATION_USER),
          res,
        }),
        showNotification(
          simpleErrorNotification({
            statusCode: res?.responseStatus,
            message:
              JSON.parse(res?.responseData)?.errors?.[0]?.message ??
              'An error has occurred while creating the user.',
          }),
        ),
      ]);
    }
  } catch (error) {}

  //   yield put({
  //     type: resolve(types?.CREATE_CUSTOMER_ORGANIZATION_USER),
  //     payload: res?.data(),
  //   });
  //   showNotification(
  //     successNotification({
  //       statusCode: 200,
  //       message: 'User created',
  //     }),
  //   );
  // } catch (error) {
  //   yield all([
  //     put({
  //       type: reject(types?.CREATE_CUSTOMER_ORGANIZATION_USER),
  //       error,
  //     }),
  //     put({
  //       type: NOTIFICATION?.ADD_NOTIFICATION,
  //       notification: errorNotification(
  //         error,
  //         reject(types?.CREATE_CUSTOMER_ORGANIZATION_USER),
  //       ),
  //     }),
  //   ]);
  // }
}

export function* deleteCustomerOrganizationUser({ organisationID, uuid }) {
  try {
    const res = yield retry(
      1,
      500,
      authClient?.Staff?.deleteCustomerOrganizationUser,
      {
        id: organisationID,
        uuid: uuid,
      },
    );

    if (
      res?.responseStatus === 200 ||
      res?.responseStatus === 201 ||
      res?.responseStatus === 204
    ) {
      yield put({
        type: resolve(types?.DELETE_CUSTOMER_ORGANIZATION_USER),
        payload: res?.data(),
      });
      showNotification(
        successNotification({
          statusCode: 204,
          message: 'User deleted',
        }),
      );
      yield put(loadCustomerOrganizationUsersListAction(organisationID));
    } else {
      yield all([
        put({
          type: reject(types?.DELETE_CUSTOMER_ORGANIZATION_USER),
          res,
        }),
        showNotification(
          simpleErrorNotification({
            statusCode: res?.responseStatus,
            message:
              JSON.parse(res?.responseData)?.errors?.[0]?.message ??
              'An error has occurred while deleting the user.',
          }),
        ),
      ]);
    }
  } catch (error) {}

  //   yield put({
  //     type: resolve(types?.DELETE_CUSTOMER_ORGANIZATION_USER),
  //     payload: res?.data(),
  //   });
  //   showNotification(
  //     successNotification({
  //       statusCode: 204,
  //       message: 'User deleted',
  //     }),
  //   );
  //   yield put(loadCustomerOrganizationUsersListAction(organisationID));
  // } catch (error) {
  //   yield all([
  //     put({
  //       type: reject(types?.DELETE_CUSTOMER_ORGANIZATION_USER),
  //       error,
  //     }),
  //     put({
  //       type: NOTIFICATION?.ADD_NOTIFICATION,
  //       notification: errorNotification(
  //         error,
  //         reject(types?.DELETE_CUSTOMER_ORGANIZATION_USER),
  //       ),
  //     }),
  //   ]);
  // }
}

export function* inviteCustomerOrganizationUser({ organisationID, uuid }) {
  try {
    const res = yield retry(
      4,
      500,
      authClient?.Staff?.inviteCustomerOrganizationUser,
      {
        id: organisationID,
        uuid: uuid,
      },
    );

    if (
      res?.responseStatus === 200 ||
      res?.responseStatus === 201 ||
      res?.responseStatus === 204
    ) {
      yield put({
        type: resolve(types?.INVITE_CUSTOMER_ORGANIZATION_USER),
        payload: res?.data(),
      });
      showNotification(
        successNotification({
          statusCode: 200,
          message: 'User invited',
        }),
      );
    } else {
      yield all([
        put({
          type: reject(types?.INVITE_CUSTOMER_ORGANIZATION_USER),
          res,
        }),
        showNotification(
          simpleErrorNotification({
            statusCode: res?.responseStatus,
            message:
              JSON.parse(res?.responseData)?.errors?.[0]?.message ??
              'An error has occurred while inviting the user.',
          }),
        ),
      ]);
    }
  } catch (error) {}

  //   yield put({
  //     type: resolve(types?.INVITE_CUSTOMER_ORGANIZATION_USER),
  //     payload: res?.data(),
  //   });
  //   showNotification(
  //     successNotification({
  //       statusCode: 200,
  //       message: 'User invited',
  //     }),
  //   );
  // } catch (error) {
  //   yield all([
  //     put({
  //       type: reject(types?.INVITE_CUSTOMER_ORGANIZATION_USER),
  //       error,
  //     }),
  //     put({
  //       type: NOTIFICATION?.ADD_NOTIFICATION,
  //       notification: errorNotification(
  //         error,
  //         reject(types?.INVITE_CUSTOMER_ORGANIZATION_USER),
  //       ),
  //     }),
  //   ]);
  // }
}

export function* addFPsCustomerOrganizationUser({ organisationID, uuid }) {
  try {
    const res = yield retry(
      1,
      500,
      authClient?.Staff?.addFPsCustomerOrganizationUser,
      {
        id: organisationID,
        uuid: uuid,
      },
    );

    if (
      res?.responseStatus === 200 ||
      res?.responseStatus === 201 ||
      res?.responseStatus === 204
    ) {
      yield put({
        type: resolve(types?.ADD_FPs_CUSTOMER_ORGANIZATION_USER),
        payload: res?.data(),
      });
      showNotification(
        successNotification({
          statusCode: 200,
          message: 'Pre-defined filter profiles updated',
        }),
      );
    } else {
      yield all([
        put({
          type: reject(types?.ADD_FPs_CUSTOMER_ORGANIZATION_USER),
          res,
        }),
        showNotification(
          simpleErrorNotification({
            statusCode: res?.responseStatus,
            message:
              JSON.parse(res?.responseData)?.errors?.[0]?.message ??
              'An error has occurred while adding filter profiles.',
          }),
        ),
      ]);
    }
  } catch (error) {}

  //   yield put({
  //     type: resolve(types?.ADD_FPs_CUSTOMER_ORGANIZATION_USER),
  //     payload: res?.data(),
  //   });
  //   showNotification(
  //     successNotification({
  //       statusCode: 200,
  //       message: 'Pre-defined filter profiles updated',
  //     }),
  //   );
  // } catch (error) {
  //   yield all([
  //     put({
  //       type: reject(types?.ADD_FPs_CUSTOMER_ORGANIZATION_USER),
  //       error,
  //     }),
  //     put({
  //       type: NOTIFICATION?.ADD_NOTIFICATION,
  //       notification: errorNotification(
  //         error,
  //         reject(types?.ADD_FPs_CUSTOMER_ORGANIZATION_USER),
  //       ),
  //     }),
  //   ]);
  // }
}

export function* loadUsersInfoForStaffMember({ text }) {
  try {
    const res = yield retry(
      4,
      500,
      authClient?.Staff?.loadUsersInfoForStaffMember,
      {
        text: text,
      },
    );

    yield put({
      type: resolve(types?.LOAD_USERS_INFO_FOR_STAFF_MEMBER),
      payload: res?.data(),
    });
  } catch (error) {
    yield all([
      put({
        type: reject(types?.LOAD_USERS_INFO_FOR_STAFF_MEMBER),
        error,
      }),
      put({
        type: NOTIFICATION?.ADD_NOTIFICATION,
        notification: errorNotification(
          error,
          reject(types?.LOAD_USERS_INFO_FOR_STAFF_MEMBER),
        ),
      }),
    ]);
  }
}

export function* transferUserFormOrgToAnother({ uuid, organisationUUID }) {
  try {
    const res = yield retry(
      1,
      500,
      authClient?.Staff?.transferUserFormOrgToAnother,
      {
        body: {
          organisation_uuid: organisationUUID,
        },
        uuid: uuid,
      },
    );

    yield put({
      type: resolve(types?.TRANSTER_USER_FROM_ORG_TO_ANOTHER),
      payload: res?.data(),
    });
    showNotification(
      successNotification({
        statusCode: 200,
        message:
          'Your request is being processed and may take some time. We appreciate your patience',
      }),
    );
  } catch (error) {
    yield all([
      put({
        type: reject(types?.TRANSTER_USER_FROM_ORG_TO_ANOTHER),
        error,
      }),
      put({
        type: NOTIFICATION?.ADD_NOTIFICATION,
        notification: errorNotification(
          error,
          reject(types?.TRANSTER_USER_FROM_ORG_TO_ANOTHER),
        ),
      }),
    ]);
  }
}

export function* notifySubscriptionExpiredCustomerOrganizationUser({ id }) {
  try {
    const res = yield retry(
      1,
      500,
      authClient?.Staff?.notifySubscriptionExpiredCustomerOrganizationUser,
      { id: id },
    );

    if (
      res?.responseStatus === 200 ||
      res?.responseStatus === 201 ||
      res?.responseStatus === 204
    ) {
      yield put({
        type: resolve(
          types?.NOTIFY_SUBSCRIPTION_EXPIRED_COMMUNITY_CUSTOMER_ORGANIZATION_USER,
        ),
        payload: res?.data(),
      });
      showNotification(
        successNotification({
          statusCode: 200,
          message: 'Notification sent',
        }),
      );
    } else {
      yield all([
        put({
          type: reject(
            types?.NOTIFY_SUBSCRIPTION_EXPIRED_COMMUNITY_CUSTOMER_ORGANIZATION_USER,
          ),
          res,
        }),
        showNotification(
          simpleErrorNotification({
            statusCode: res?.responseStatus,
            message:
              JSON.parse(res?.responseData)?.errors?.[0]?.message ??
              'An error has occurred while sending the notification.',
          }),
        ),
      ]);
    }
  } catch (error) {}

  //   yield put({
  //     type: resolve(
  //       types?.NOTIFY_SUBSCRIPTION_EXPIRED_COMMUNITY_CUSTOMER_ORGANIZATION_USER,
  //     ),
  //     payload: res?.data(),
  //   });
  //   showNotification(
  //     successNotification({
  //       statusCode: 200,
  //       message: 'Notification sent',
  //     }),
  //   );
  // } catch (error) {
  //   yield all([
  //     put({
  //       type: reject(
  //         types?.NOTIFY_SUBSCRIPTION_EXPIRED_COMMUNITY_CUSTOMER_ORGANIZATION_USER,
  //       ),
  //       error,
  //     }),
  //     put({
  //       type: NOTIFICATION?.ADD_NOTIFICATION,
  //       notification: errorNotification(
  //         error,
  //         reject(
  //           types?.NOTIFY_SUBSCRIPTION_EXPIRED_COMMUNITY_CUSTOMER_ORGANIZATION_USER,
  //         ),
  //       ),
  //     }),
  //   ]);
  // }
}

export function* setOrganizationActive({ organisationUUID, date }) {
  try {
    const res = yield retry(4, 500, authClient?.Staff?.setOrganizationActive, {
      body: { expiration_date: date },
      uuid: organisationUUID,
    });

    if (
      res?.responseStatus === 200 ||
      res?.responseStatus === 201 ||
      res?.responseStatus === 204
    ) {
      yield put({
        type: resolve(types?.SET_ORGANIZATION_ACTIVE),
        payload: res?.data(),
      });
      showNotification(
        successNotification({
          statusCode: 200,
          message: 'Organization activated',
        }),
      );
    } else {
      yield all([
        put({
          type: reject(types?.SET_ORGANIZATION_ACTIVE),
          res,
        }),
        showNotification(
          simpleErrorNotification({
            statusCode: res?.responseStatus,
            message:
              JSON.parse(res?.responseData)?.errors?.[0]?.message ??
              'An error has occurred while activating the organization.',
          }),
        ),
      ]);
    }
  } catch (error) {}

  //   yield put({
  //     type: resolve(types?.SET_ORGANIZATION_ACTIVE),
  //     payload: res?.data(),
  //   });
  //   showNotification(
  //     successNotification({
  //       statusCode: 200,
  //       message: 'Organization activated',
  //     }),
  //   );
  // } catch (error) {
  //   yield all([
  //     put({
  //       type: reject(types?.SET_ORGANIZATION_ACTIVE),
  //       error,
  //     }),
  //     put({
  //       type: NOTIFICATION?.ADD_NOTIFICATION,
  //       notification: errorNotification(
  //         error,
  //         reject(types?.SET_ORGANIZATION_ACTIVE),
  //       ),
  //     }),
  //   ]);
  // }
}

export function* setOrganizationInactive({ organisationUUID }) {
  try {
    const res = yield retry(
      4,
      500,
      authClient?.Staff?.setOrganizationInactive,
      {
        uuid: organisationUUID,
      },
    );

    if (
      res?.responseStatus === 200 ||
      res?.responseStatus === 201 ||
      res?.responseStatus === 204
    ) {
      yield put({
        type: resolve(types?.SET_ORGANIZATION_INACTIVE),
        payload: res?.data(),
      });
      showNotification(
        successNotification({
          statusCode: 200,
          message: 'Organization deactivated',
        }),
      );
    } else {
      yield all([
        put({
          type: reject(types?.SET_ORGANIZATION_INACTIVE),
          res,
        }),
        showNotification(
          simpleErrorNotification({
            statusCode: res?.responseStatus,
            message:
              JSON.parse(res?.responseData)?.errors?.[0]?.message ??
              'An error has occurred while deactivating the organization.',
          }),
        ),
      ]);
    }
  } catch (error) {}

  //   yield put({
  //     type: resolve(types?.SET_ORGANIZATION_INACTIVE),
  //     payload: res?.data(),
  //   });
  //   showNotification(
  //     successNotification({
  //       statusCode: 200,
  //       message: 'Organization deactivated',
  //     }),
  //   );
  // } catch (error) {
  //   yield all([
  //     put({
  //       type: reject(types?.SET_ORGANIZATION_INACTIVE),
  //       error,
  //     }),
  //     put({
  //       type: NOTIFICATION?.ADD_NOTIFICATION,
  //       notification: errorNotification(
  //         error,
  //         reject(types?.SET_ORGANIZATION_INACTIVE),
  //       ),
  //     }),
  //   ]);
  // }
}
